import { getCurrentEnvForClientSide, PRODUCTION } from '@zg-rentals/environment-utils/client';

const PRODUCTION_ESUSU_BASE_URL = 'https://raas-app.esusu.io';
const SANDBOX_ESUSU_BASE_URL = 'https://raas-app.sandbox.esusu.io';

const PRODUCTION_PUBLIC_KEY = '0WHGXAN2GDWL0C9P880WKX87G6YCU33';
const QA_PUBLIC_KEY = 'A7XK3FZL9B8T2WQC4YD0MNR5G1VEJH6S';

export const getEsusuBaseUrl = () => {
  if (typeof window !== 'undefined') {
    const env = getCurrentEnvForClientSide();
    if (env === PRODUCTION) {
      return PRODUCTION_ESUSU_BASE_URL;
    }
  }
  return SANDBOX_ESUSU_BASE_URL;
};

export const getPublicKeyForEnv = () => {
  if (typeof window !== 'undefined') {
    const env = getCurrentEnvForClientSide();
    if (env === PRODUCTION) {
      return PRODUCTION_PUBLIC_KEY;
    }
  }
  return QA_PUBLIC_KEY;
};
